import type {PermissionsRecordType} from '../permissions';

export const warehousePermissions = {
  vehicleWarehouseRead: {
    actionId: 'READ',
    resourceId: 'VEHICLE_WAREHOUSE',
    scopes: [],
  },
  vehicleWarehouseCreate: {
    actionId: 'CREATE',
    resourceId: 'VEHICLE_WAREHOUSE',
    scopes: [],
  },
  vehicleWarehouseEdit: {
    actionId: 'UPDATE',
    resourceId: 'VEHICLE_WAREHOUSE',
    scopes: [],
  },
  pneuhotelRead: {
    resourceId: 'TIRE_ORDER',
    actionId: 'READ',
    scopes: [],
  },
  articleCreate: {
    resourceId: 'ARTICLE',
    actionId: 'CREATE',
    scopes: [],
  },
  articleEdit: {
    resourceId: 'ARTICLE',
    actionId: 'EDIT',
    scopes: [],
  },
  articleRead: {
    resourceId: 'ARTICLE',
    actionId: 'READ',
    scopes: [],
  },
  receiveNoteCreate: {
    resourceId: 'RECEIVE_NOTE',
    actionId: 'CREATE',
    scopes: [],
  },
  receiveNoteRead: {
    resourceId: 'RECEIVE_NOTE',
    actionId: 'READ',
    scopes: [],
  },
  receiveNoteEdit: {
    resourceId: 'RECEIVE_NOTE',
    actionId: 'EDIT',
    scopes: [],
  },
  supplierOrderRead: {
    resourceId: 'SUPPLIER_ORDER',
    actionId: 'READ',
    scopes: [],
  },
  supplierOrderCreate: {
    resourceId: 'SUPPLIER_ORDER',
    actionId: 'CREATE',
    scopes: [],
  },
  supplierOrderEdit: {
    resourceId: 'SUPPLIER_ORDER',
    actionId: 'EDIT',
    scopes: [],
  },
  supplierOrderDelete: {
    resourceId: 'SUPPLIER_ORDER',
    actionId: 'DELETE',
    scopes: [],
  },
  supplierOrderLock: {
    resourceId: 'SUPPLIER_ORDER',
    actionId: 'LOCK',
    scopes: [],
  },
  supplierOrderUnlock: {
    resourceId: 'SUPPLIER_ORDER',
    actionId: 'UNLOCK',
    scopes: [],
  },
  supplierOrderSend: {
    resourceId: 'SUPPLIER_ORDER',
    actionId: 'SEND',
    scopes: [],
  },
  deliveryNoteRead: {
    resourceId: 'DELIVERY_NOTE',
    actionId: 'READ',
    scopes: [],
  },
  deliveryNoteAiExtract: {
    resourceId: 'DELIVERY_NOTE',
    actionId: 'AI_EXTRACT',
    scopes: [],
  },
  deliveryNoteEdit: {
    resourceId: 'DELIVERY_NOTE',
    actionId: 'EDIT',
    scopes: [],
  },
  deliveryNoteDownload: {
    resourceId: 'DELIVERY_NOTE',
    actionId: 'DOWNLOAD',
    scopes: [],
  },
  directSaleRead: {
    resourceId: 'DIRECT_SALE',
    actionId: 'READ',
    scopes: [],
  },
  directSaleActivityRead: {
    resourceId: 'DIRECT_SALE',
    actionId: 'ACTIVITY_READ',
    scopes: [],
  },
  directSaleActivityCreate: {
    resourceId: 'DIRECT_SALE',
    actionId: 'ACTIVITY_CREATE',
    scopes: [],
  },
  directSaleActivityUpdate: {
    resourceId: 'DIRECT_SALE',
    actionId: 'ACTIVITY_UPDATE',
    scopes: [],
  },
  directSaleActivityDelete: {
    resourceId: 'DIRECT_SALE',
    actionId: 'ACTIVITY_DELETE',
    scopes: [],
  },
  directSaleCommentRead: {
    resourceId: 'DIRECT_SALE',
    actionId: 'COMMENT_READ',
    scopes: [],
  },
  directSaleCommentAdd: {
    resourceId: 'DIRECT_SALE',
    actionId: 'COMMENT_ADD',
    scopes: [],
  },
  directSaleCommentDelete: {
    resourceId: 'DIRECT_SALE',
    actionId: 'COMMENT_DELETE',
    scopes: [],
  },
  directSaleCreate: {
    resourceId: 'DIRECT_SALE',
    actionId: 'CREATE',
    scopes: [],
  },
  directSaleEdit: {
    resourceId: 'DIRECT_SALE',
    actionId: 'EDIT',
    scopes: [],
  },
  directSaleDelete: {
    resourceId: 'DIRECT_SALE',
    actionId: 'DELETE',
    scopes: [],
  },
  directSaleCheckout: {
    resourceId: 'DIRECT_SALE',
    actionId: 'CHECKOUT',
    scopes: [],
  },
  directSalesRead: {
    resourceId: 'DIRECT_SALES',
    actionId: 'READ',
    scopes: [],
  },
  returnToWarehouseRead: {
    resourceId: 'RETURN_TO_WAREHOUSE',
    actionId: 'READ',
    scopes: [],
  },
  returnToWarehouseCreate: {
    resourceId: 'RETURN_TO_WAREHOUSE',
    actionId: 'CREATE',
    scopes: [],
  },
  warehouseDictionaryRead: {
    resourceId: 'WAREHOUSE_DICTIONARY',
    actionId: 'READ',
    scopes: [],
  },
  warehouseDictionaryCreate: {
    resourceId: 'WAREHOUSE_DICTIONARY',
    actionId: 'CREATE',
    scopes: [],
  },
  warehouseDictionaryEdit: {
    resourceId: 'WAREHOUSE_DICTIONARY',
    actionId: 'EDIT',
    scopes: [],
  },
  warehouseDictionaryDelete: {
    resourceId: 'WAREHOUSE_DICTIONARY',
    actionId: 'DELETE',
    scopes: [],
  },
  receiveNoteCorrectionRead: {
    resourceId: 'RECEIVE_NOTE_CORRECTION',
    actionId: 'READ',
    scopes: [],
  },
  receiveNoteCorrectionCreate: {
    resourceId: 'RECEIVE_NOTE_CORRECTION',
    actionId: 'CREATE',
    scopes: [],
  },
  receiveNoteCorrectionEdit: {
    resourceId: 'RECEIVE_NOTE_CORRECTION',
    actionId: 'EDIT',
    scopes: [],
  },
  receiveNoteCorrectionDelete: {
    resourceId: 'RECEIVE_NOTE_CORRECTION',
    actionId: 'DELETE',
    scopes: [],
  },
  receiveNoteCorrectionComplete: {
    resourceId: 'RECEIVE_NOTE_CORRECTION',
    actionId: 'COMPLETE',
    scopes: [],
  },
  receiveNoteCorrectionEditCompleted: {
    resourceId: 'RECEIVE_NOTE_CORRECTION',
    actionId: 'EDIT_COMPLETED',
    scopes: [],
  },
  articleUpdateJobRead: {
    resourceId: 'ARTICLE_UPDATE_JOB',
    actionId: 'READ',
    scopes: [],
  },
  articleUpdateJobCreate: {
    resourceId: 'ARTICLE_UPDATE_JOB',
    actionId: 'CREATE',
    scopes: [],
  },
  articleUpdateJobEdit: {
    resourceId: 'ARTICLE_UPDATE_JOB',
    actionId: 'EDIT',
    scopes: [],
  },
  articleUpdateJobDelete: {
    resourceId: 'ARTICLE_UPDATE_JOB',
    actionId: 'DELETE',
    scopes: [],
  },
  articleUpdateJobApproval: {
    resourceId: 'ARTICLE_UPDATE_JOB',
    actionId: 'APPROVAL',
    scopes: [],
  },
  fastTrackIssueRead: {
    resourceId: 'FAST_TRACK',
    actionId: 'READ',
    scopes: [],
  },
  fastTrackIssueCreate: {
    resourceId: 'FAST_TRACK',
    actionId: 'CREATE',
    scopes: [],
  },
  fastTrackIssueEdit: {
    resourceId: 'FAST_TRACK',
    actionId: 'UPDATE',
    scopes: [],
  },
  fastTrackComplete: {
    resourceId: 'FAST_TRACK',
    actionId: 'COMPLETE',
    scopes: [],
  },
  transferOrderRead: {
    resourceId: 'TRANSFER_ORDER',
    actionId: 'READ',
    scopes: [],
  },
  transferOrderCreate: {
    resourceId: 'TRANSFER_ORDER',
    actionId: 'CREATE',
    scopes: [],
  },
  transferOrderEdit: {
    resourceId: 'TRANSFER_ORDER',
    actionId: 'UPDATE',
    scopes: [],
  },
  aiToolRead: {
    resourceId: 'AI_TOOL',
    actionId: 'READ',
    scopes: [],
  },
  aiToolInvoiceExtractionFromFile: {
    resourceId: 'AI_TOOL',
    actionId: 'INVOICE_EXTRACTION_FROM_FILE',
    scopes: [],
  },
  aiToolInvoiceExtractionFromZip: {
    resourceId: 'AI_TOOL',
    actionId: 'INVOICE_EXTRACTION_FROM_ZIP',
    scopes: [],
  },
  warehouseReportingRead: {
    resourceId: 'WAREHOUSE_REPORTING',
    actionId: 'READ',
    scopes: [],
  },
  warehouseReportingHyundaiMobisIrisRead: {
    resourceId: 'WAREHOUSE_REPORTING',
    actionId: 'HYUNDAI_MOBIS_IRIS_READ',
    scopes: [],
  },
  // Scopes intentionally empty: the backend enforces branch/warehouse filtering, and the frontend
  // evaluates WAREHOUSE as granted only on ARTICLE - add an evaluator before declaring scopes here.
  warehouseReportingDailyStockTakeRead: {
    resourceId: 'WAREHOUSE_REPORTING',
    actionId: 'DAILY_STOCK_TAKE_READ',
    scopes: [],
  },
  coreExchangeRead: {
    resourceId: 'CORE_EXCHANGE',
    actionId: 'READ',
    scopes: [],
  },
  coreExchangeCreate: {
    resourceId: 'CORE_EXCHANGE',
    actionId: 'CREATE',
    scopes: [],
  },
  coreExchangeEdit: {
    resourceId: 'CORE_EXCHANGE',
    actionId: 'EDIT',
    scopes: [],
  },
} satisfies PermissionsRecordType;
